<template>
  <div class="col mt-3">
    <el-form :model="Data" label-position="top" status-icon ref="Data" size="mini" label-width="120px">
      <div class="card">
        <div class="card-header bg-transparent">
          <div class="row">
            <div class="col-6">
              <h3 class="card-title mb-0"> {{$t('firma.firma')}} </h3>
              <small class="md-truncate flex">{{$t('firma.firmaaciklama')}}</small>
            </div>
          </div>
        </div>


        <div class="card-body p-3">


          <!---===== Print Area =======-->
          <div id="print-area">
            <div class="row">
              <div class="col-md-4">
                <el-form-item
                  :label="$t('firma.unvan')"
                  prop="unvan"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.unvan"
                            autocomplete="off" :placeholder="$t('firma.unvan')"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4">
                <el-form-item
                  :label="$t('firma.adi')"
                  prop="adi"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.adi"
                            autocomplete="off" :placeholder="$t('firma.adi')"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-4">
                <el-form-item
                  :label="$t('firma.fno')"
                  prop="fno"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.fno"
                            autocomplete="off" :placeholder="$t('firma.fno')"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-3">
                <el-form-item
                  :label="$t('firma.telefon')"
                  prop="telefon"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.telefon"
                            autocomplete="off" :placeholder="$t('firma.telefon')"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-3">
                <el-form-item
                  label="Fax"
                  prop="faks"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.faks"
                            autocomplete="off" placeholder="Fax"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-3">
                <el-form-item
                  label="Email"
                  prop="email"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.email"
                            autocomplete="off" :placeholder="$t('firma.email')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-3">
                <el-form-item
                  :label="$t('firma.web')"
                  prop="web"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.web"
                            autocomplete="off" :placeholder="$t('firma.web')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-3">
                <el-form-item
                  :label="$t('firma.badi')"
                  prop="badi"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.badi"
                            autocomplete="off" :placeholder="$t('firma.badi')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-3">
                <el-form-item
                  :label="$t('firma.iban')"
                  prop="iban"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.iban"
                            autocomplete="off" :placeholder="$t('firma.iban')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-3">
                <el-form-item
                  :label="$t('firma.vdaire')"
                  prop="vdairesi"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.vdairesi"
                            autocomplete="off" :placeholder="$t('firma.vdaire')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-3">
                <el-form-item
                  :label="$t('firma.vno')"
                  prop="vno"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.vno"
                            autocomplete="off" :placeholder="$t('firma.vno')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-4">
                <el-form-item
                  :label="$t('firma.adres')"
                  prop="adres"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.adres"
                            autocomplete="off" :placeholder="$t('firma.adres')"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-4">
                <el-form-item
                  :label="$t('firma.pkodu')"
                  prop="pkodu"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.pkodu"
                            autocomplete="off" :placeholder="$t('firma.pkodu')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-4">
                <el-form-item
                  :label="$t('firma.sehir')"
                  prop="sehir"
                  autocomplete="off"
                  :rules="[{ required: true, message: $t('bos') }]"
                >
                  <el-input type="text" v-model="Data.sehir"
                            autocomplete="off" :placeholder="$t('firma.sehir')"></el-input>
                </el-form-item>
              </div>


              <div class="col-md-12">
                <img :src="Data.logo" alt="" width="100" class="pb-2">

              </div>




              <div class="col-md-12 pull-right text-right">
                <button @click="onSubmit('Data')" type="button" class="btn btn-sm btn-info">{{$t("kaydet")}}</button>
              </div>


            </div>


          </div>
        </div>
      </div>


    </el-form>

  </div>
</template>

<script>
  import notification from "@/notification";

  export default {
    data() {
      return {
        Data: {},
        imageUrl: ''
      }
    },
    methods: {


      HesapListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/bilgi/hesap"})
          .then(response => {
            if (response.Status == 'OK') {
              this.Data = response.Data;
            }
          });
      },


      onSubmit(formName) {

        this.$refs[formName].validate((valid) => {
          if (valid) {

            this.$store.dispatch("dataver", {
              method: 'put',
              url: '/bilgi/',
              data: this.Data
            }).then(response => {
              console.log(response)
              this.$message({
                type: 'success',
                message: this.$t('siluyari.1')
              });

            })


          }
        });
      },

      submitUpload() {
        this.$refs.upload.submit();
      }


    },
    created() {
      this.HesapListele();
    },

  }
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/Module/ayar.vue